import { Injectable } from '@angular/core';
import { CommodityModel } from '@shared/models/commodity.model';
import { Utilities } from '@shared/utilities/utilities.model';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CommoditiesUtilityService {

  constructor() { }

  private _currentCommodities: CommodityModel[];
  private _multiCommodities: boolean;

  public get multiCommodities(): boolean {
    return this._multiCommodities;
  }
  public set multiCommodities(value: boolean) {
    this._multiCommodities = value;
  }


  public get currentCommodities(): CommodityModel[] {
    return this._currentCommodities;
  }
  public set currentCommodities(value: CommodityModel[]) {
    this._currentCommodities = value;
  }

  public manageMultiCommoditiesForHeader(isSuperUser: boolean, commodities:string) : string {
    if(!isSuperUser){
      if(this.currentCommodities && commodities){
        if(commodities.split(',').filter(commodity  => commodity !== "").length == this.currentCommodities.length){
          return null;
        } 
      }
    }
    return commodities;
  }


}
